import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getPOOrders,
  getPendingShipmentCreation,
  getPackingList,
} from "../../services/apiService"; // same file you shared
import "./styles/Dashboard.css";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [poOrders, setPoOrders] = useState([]);
  const [shipments, setShipments] = useState([]);
  const [packingList, setPackingListData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [poRes, shipRes, packRes] = await Promise.all([
        getPOOrders(),
        getPendingShipmentCreation(),
        getPackingList(),
      ]);

      const safeArray = (res) =>
        Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res)
              ? res
              : [];

      setPoOrders(safeArray(poRes));
      setShipments(safeArray(shipRes));
      setPackingListData(safeArray(packRes));
    } catch (error) {
      console.error("Dashboard API error", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="dashboard-loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard-wrapper">
      <h2 className="dashboard-title">Dashboard page</h2>

      <div className="dashboard-cards">
        {/* PO ORDERS */}
        <div className="dashboard-card" onClick={() => navigate("/adminsidebar", { state: { activeSection: "Warehouse" } })} style={{ cursor: "pointer" }}>
          <div className="card-header">PO Orders:</div>
          <div className="card-body">
            <h4 style={{color:"black"}}>Pending Orders for packing</h4>
            <p>
              <strong>{poOrders.length}</strong> Orders pending for packing
            </p>
          </div>
          <div className="card-footer">
            {poOrders.slice(0, 3).map((item, index) => (
              <span key={index}>
                {item.po_number || item.orderid || item.id} {index < 2 && " | "}
              </span>
            ))}
          </div>
        </div>

        {/* SHIPMENT */}
        <div className="dashboard-card" onClick={() => navigate("/adminsidebar", { state: { activeSection: "Warehouse" } })} style={{ cursor: "pointer" }}>
          <div className="card-header">Shipment:</div>
          <div className="card-body">
            <h4>Pending shipment creation</h4>
            <p>
              <strong>{shipments.length}</strong> orders ready for shipment
              creation
            </p>
          </div>
        </div>

        {/* PICKUP */}
        <div className="dashboard-card" onClick={() => navigate("/adminsidebar", { state: { activeSection: "Warehouse" } })} style={{ cursor: "pointer" }}>
          <div className="card-header">Pickup:</div>
          <div className="card-body">
            <h4>Pickup request</h4>
            <p>
              <strong>{packingList.length}</strong> orders ready for pickup
              request
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
